/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import * as React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IconButton, Tooltip } from '@mui/material';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

function CopyInput({ id }) {
  // const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    // setOpen(true);
    toast.success('Record ID copied!', {
      position: 'bottom-center',
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light'
    });
  };

  return (
    <>
      <CopyToClipboard text={id} onCopy={() => handleClick()}>
        <Tooltip title="Copy Record ID" arrow>
          <IconButton aria-label="settings" size="small">
            <ContentCopyIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </CopyToClipboard>
      {/* <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /> */}
      {/* <Snackbar
        onClose={handleClose}
        open={open}
        disableWindowBlurListener
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{
          top: '0px !important'
        }}
        autoHideDuration={1000}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{
            width: '100%'
            // position: 'fixed',
            // bottom: '0px',
            // left: '0px',
            // right: '0px'
          }}>
          Record ID copied!
        </Alert>
      </Snackbar> */}
    </>
  );
}

CopyInput.propTypes = {
  id: PropTypes.string.isRequired
};

export default CopyInput;
